import { DataHeaderType } from "components/table/TableRowComponent";

export const HEADER_EST_DISCOUNT: DataHeaderType[] = [
  {
    label: "交換工賃",
    sx: {
      width: "142px",
      backgroundColor: "var(--green-600)",
    },
  },
  {
    label: "処分",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "バルブ",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "窒素",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "ハプ防錆",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "パンク補償",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "キャッシュバック",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
      whiteSpace: "nowrap",
    },
  },
];

export const HEADER_EST_RESULT: DataHeaderType[] = [
  {
    label: "選択",
    sx: {
      width: "122px",
    },
    rowSpan: 2,
  },
  {
    label: "メーカー",
    sx: {
      width: "271px",
    },
  },
  {
    label: "LI/速度記号",
    sx: {
      width: "164px",
    },
  },
  {
    label: "本数",
    sx: {
      width: "171px",
    },
  },
  {
    label: "割引率(%)",
    sx: {
      width: "193px",
    },
  },
  {
    label: "工賃",
    sx: {
      minWidth: "142px",
      width: "142px",
    },
  },
  {
    label: "パンク補償価格",
    sx: {
      minWidth: "200px",
      width: "200px",
    },
  },
  {
    label: "キャッシュバック",
    sx: {
      minWidth: "175px",
      width: "175px",
      px: "2px",
    },
  },
  {
    label: "備考",
    sx: {
      width: "auto",
    },
    rowSpan: 2,
  },
];

export const HEADER_EST_SUB_RESULT: DataHeaderType[] = [
  {
    label: "商品名",
  },
  {
    label: "ラベリング",
  },
  {
    label: "通常価格",
  },
  {
    label: "割引後価格",
  },
  {
    label: "工賃込価格",
  },
  {
    label: "パンク補償込価格",
  },
  {
    label: "最終金額",
    sx: { backgroundColor: "var(--red-500)" },
  },
];

export const HEADER_QUOTATION_DISCOUNT: DataHeaderType[] = [
  {
    label: "交換工賃",
    sx: {
      width: "142px",
      backgroundColor: "var(--green-600)",
    },
  },
  {
    label: "処分",
    sx: {
      width: "142px",
      backgroundColor: "var(--green-600)",
    },
  },
  {
    label: "バルブ",
    sx: {
      width: "142px",
      backgroundColor: "var(--green-600)",
    },
  },
  {
    label: "窒素",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "ハブ防錆",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "パンク補償",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "キャッシュバック",
    sx: {
      width: "220px",
      borderLeftWidth: "10px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "丸め",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
];

export const HEADER_QUOTATION_DETAIL: DataHeaderType[] = [
  {
    label: "メーカー",
    sx: {
      width: "295px",
    },
  },
  {
    label: "LI / 速度記号",
    sx: {
      width: "164px",
      px: "2px",
    },
  },
  {
    label: "本数",
    sx: {
      width: "171px",
    },
  },
  {
    label: "割引率",
    sx: {
      width: "193px",
    },
  },
  {
    label: "工賃",
    sx: {
      minWidth: "142px",
      width: "142px",
    },
  },
  {
    label: "パンク補償価格",
    sx: {
      minWidth: "186px",
      width: "186px",
    },
  },
  {
    label: "キャッシュバック",
    sx: {
      minWidth: "175px",
      width: "175px",
      letterSpacing: "-5px",
      px: "2px",
    },
  },
  {
    label: "備考",
    sx: {
      width: "420px",
    },
    rowSpan: 2,
  },
];

export const SUB_HEADER_QUOTATION_DETAIL: DataHeaderType[] = [
  {
    label: "商品名",
  },
  {
    label: "ラベリング",
    sx: { px: "2px" },
  },
  {
    label: "通常価格",
  },
  {
    label: "割引後価格",
  },
  {
    label: "工賃込価格",
  },
  {
    label: "パンク補償込価格",
    sx: { px: "2px" },
  },
  {
    label: "最終価格",
  },
];

export const HEADER_EST_PDF_DISCOUNT: DataHeaderType[] = [
  {
    label: "交換工賃",
    sx: {
      width: "142px",
      backgroundColor: "var(--green-600)",
    },
  },
  {
    label: "処分",
    sx: {
      width: "142px",
      backgroundColor: "var(--green-600)",
    },
  },
  {
    label: "エアバルブ",
    sx: {
      width: "142px",
      backgroundColor: "var(--green-600)",
    },
  },
  {
    label: "窒素",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "ハブ防錆",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "パンク補償",
    sx: {
      width: "142px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
];

export const HEADER_WHEEL_NUTS_PDF: DataHeaderType[] = [
  {
    label: "ナット",
    sx: {
      width: "333px",
      backgroundColor: "var(--green-600)",
    },
  },
  {
    label: "ロックナット",
    sx: {
      width: "249px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
  {
    label: "ハブリング",
    sx: {
      width: "223px",
      backgroundColor: "var(--offwhite-500)",
    },
  },
];

export const HEADER_EST_PDF: DataHeaderType[] = [
  {
    label: "メーカー/商品名/サイズ",
    colSpan: 1,
    sx: {
      width: "360px",
      minWidth: "300px",
      height: "68px",
      textAlign: "left",
    },
  },
  {
    label: "LI / 速度記号",
    sx: {
      width: "130px",
      px: "2px",
    },
  },
  {
    label: "ラベリング",
    sx: {
      width: "137px",
      px: "2px",
    },
  },
  {
    label: "本数",
    sx: {
      width: "76px",
    },
  },
  {
    label: "通常価格",
    sx: {
      width: "117px",
    },
  },
  {
    label: "割引率",
    sx: {
      width: "117px",
    },
  },
  {
    label: "割引後\n価格",
    sx: {
      width: "117px",
    },
  },
  {
    label: "工賃",
    sx: {
      width: "137px",
    },
  },
  {
    label: "パンク補償価格",
    sx: {
      width: "120px",
      px: "5px",
    },
  },
  {
    label: "値引き",
    sx: {
      width: "130px",
    },
  },
  {
    label: "見積金額",
    sx: {
      width: "182px",
    },
  },
  {
    label: "キャッシュバック",
    sx: {
      minWidth: "84px",
      width: "84px",
      fontSize: "14px",
      px: "5px",
    },
  },
];

export const HEADER_WHEEL_PDF: DataHeaderType[] = [
  {
    label: "ホイールメーカー",
    sx: {
      minWidth: "197px",
      height: "68px",
      width: "12%",
      whiteSpace: "nowrap",
      px: "2px",
    },
  },
  {
    label: "サイズ/ハブ径",
    sx: {
      minWidth: "60px",
      width: "3%",
      whiteSpace: "nowrap",
    },
  },
  {
    label: "本数",
    sx: {
      minWidth: "150px",
      width: "10%",
      whiteSpace: "nowrap",
      px: "2px",
    },
  },
  {
    label: "割引率",
    sx: {
      minWidth: "148px",
      width: "10%",
      whiteSpace: "nowrap",
      px: "2px",
    },
  },
  {
    label: "オプション合計",
    sx: {
      minWidth: "170px",
      width: "10%",
      whiteSpace: "nowrap",
      px: "2px",
    },
  },
  {
    label: "ホイールブランド",
    sx: {
      minWidth: "197px",
      height: "68px",
      width: "12%",
      whiteSpace: "nowrap",
      px: "2px",
    },
  },
  {
    label: "カラー",
    sx: {
      px: "2px",
    },
  },
  {
    label: "通常価格",
    sx: {
      px: "2px",
    },
  },
  {
    label: "割引後価格",
    sx: {
      px: "2px",
    },
  },
  {
    label: "ホイール合計",
    sx: {
      px: "2px",
    },
  },
];

export const HEADER_WHEEL_TIRE_EST_PDF: DataHeaderType[] = [
  {
    label: "メーカー/商品名/サイズ",
    colSpan: 1,
    sx: {
      width: "389px",
      minWidth: "389px",
      height: "68px",
      textAlign: "left",
    },
  },
  {
    label: "LI",
    sx: {
      width: "76px",
    },
  },
  {
    label: "ラベリング",
    sx: {
      width: "137px",
    },
  },
  {
    label: "本数",
    sx: {
      width: "76px",
    },
  },
  {
    label: "通常価格",
    sx: {
      width: "117px",
    },
  },
  {
    label: "割引率",
    sx: {
      width: "117px",
    },
  },
  {
    label: "割引後\n価格",
    sx: {
      width: "117px",
    },
  },
  {
    label: "工賃",
    sx: {
      width: "137px",
    },
  },
  {
    label: "パンク補償価格",
    sx: {
      width: "120px",
      px: "5px",
    },
  },
  {
    label: "値引き",
    sx: {
      width: "130px",
    },
  },
  {
    label: "見積金額",
    sx: {
      width: "182px",
    },
  },
  {
    label: "キャッシュバック",
    sx: {
      minWidth: "84px",
      width: "84px",
      fontSize: "14px",
      px: "5px",
    },
  },
];

export const HEADER_QUOTATION_LIST: DataHeaderType[] = [
  {
    label: "店舗コード",
    sx: {
      width: "159px",
      height: "68px",
    },
  },
  {
    label: "見積番号",
    sx: {
      width: "160px",
    },
  },
  {
    label: "見積作成者",
    sx: {
      width: "150px",
      whiteSpace: "nowrap",
      px: "2px",
    },
  },
  {
    label: "作成日",
    sx: {
      width: "209px",
    },
  },
  {
    label: "有効期限",
    sx: {
      width: "209px",
    },
  },
  {
    label: "お客様氏名",
    sx: {
      width: "209px",
    },
  },
  {
    label: "お客様電話番号",
    sx: {
      width: "209px",
    },
  },
  {
    label: "車両",
    sx: {
      width: "179px",
    },
  },
  // {
  //   label: "発注日",
  //   sx: {
  //     width: "150px",
  //   },
  // },
  {
    label: "詳細",
    sx: {
      width: "209px",
    },
  },
];

export const HEADER_PRICE_SETTING: DataHeaderType[] = [
  {
    label: "ブランドコード",
    sx: {
      width: "180px",
      whiteSpace: "nowrap",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
      px: "10px",
    },
  },
  {
    label: "メーカー名",
    sx: {
      width: "223px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "ブランド名",
    sx: {
      width: "395px",
      textAlign: "left",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "中分類",
    sx: {
      width: "240px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "A表売価掛率",
    sx: {
      width: "160px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "固定割引（％）",
    sx: {
      width: "190px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "利益率（％）",
    sx: {
      width: "190px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
      px: '2px'
    },
  },
];

export const HEADER_TIRE_LIST: DataHeaderType[] = [
  {
    label: "YH商品コード",
    sx: { width: "203px" },
  },
  // {
  //   label: "ブランドコード",
  //   sx: { width: "209px", textAlign: "center" },
  // },
  {
    label: "メーカー名",
    sx: { width: { lg: "203px", xs: "280px" }, textAlign: "center" },
  },
  {
    label: "ブランド名",
    sx: { width: { lg: "336px", xs: "280px" } },
  },
  {
    label: "タイヤサイズ",
    sx: { width: "216px" },
  },
  {
    label: "LI/速度記号",
    sx: { width: "216px" },
  },
  {
    label: "詳細",
    sx: { width: "209px" },
  },
];

export const HEADER_4BUNDLE_PRICE_SETTING: DataHeaderType[] = [
  {
    label: "YH商品コード",
    sx: {
      width: "174px",
      whiteSpace: "nowrap",
      textAlign: "left",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "ブランドコード",
    sx: {
      width: "191px",
      textAlign: "left",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "メーカー/ ブランド名",
    sx: {
      width: "290px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "サイズ",
    sx: {
      width: "173px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "タイヤ4本特価",
    sx: {
      width: "170px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "廉価ホイールセット4本特価",
    sx: {
      width: "211px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  // {
  //   label: "操作",
  //   sx: {
  //     width: "222px",
  //     textAlign: "center",
  //     border: "2px solid var(--primary-500)",
  //   },
  // },
];

export const HEADER_WHEEL_PRICE_SETTING: DataHeaderType[] = [
  {
    label: "ブランドコード",
    sx: {
      width: "174px",
      whiteSpace: "nowrap",
      textAlign: "center",
      px: 1.5,
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "メーカー名",
    sx: {
      width: "223px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "ブランド名",
    sx: {
      width: "396px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "粗利率（％）",
    sx: {
      width: "211px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
  {
    label: "固定割引（％）",
    sx: {
      width: "211px",
      textAlign: "center",
      border: "2px solid var(--primary-500)",
    },
  },
];

export const SPECS_TIRE_DETAIL = [
  { label: "YH商品コード", value: "item_cd" },
  { label: "JANコード", value: "" },
  { label: "ブランドコード", value: "" },
  { label: "商品名", value: "", isTextField: true },
  { label: "サイズ", value: "" },
  { label: "商品カテゴリ（大）", value: "" },
  { label: "商品カテゴリ（中）", value: "" },
  { label: "商品カテゴリ（小）", value: "" },
  { label: "定価", value: "" },
  { label: "A表価格", value: "" },
  { label: "仕入先コード", value: "" },
  { label: "仕入先原価", value: "" },
  { label: "2次仕入先コード", value: "" },
  { label: "2次仕入先原価", value: "" },
  { label: "発注先", value: "" },
  { label: "ECフラグ", value: "" },
  { label: "直送フラグ", value: "" },
  { label: "無効フラグ", value: "" },
];

export const HEADER_TIRE_BRAND: DataHeaderType[] = [
  {
    label: "ブランドコード",
    sx: { borderLeftWidth: "2px", width: "180px", textAlign: "center", px: "10px" },
  },
  {
    label: "メーカー名",
    sx: { borderLeftWidth: "2px", width: "223px", textAlign: "left" },
  },
  {
    label: "ブランド名",
    sx: { borderLeftWidth: "2px", width: { lg: "396px", xs: "280px" }, textAlign: "left" },
  },
  {
    label: "中分類",
    sx: {
      width: "230px",
      textAlign: "center",
      borderLeftWidth: "2px",
    },
  },
  {
    label: "A表\n売価掛け率",
    sx: { borderLeftWidth: "2px", width: "185px", textAlign: "center", px: '4px' },
  },
  {
    label: "固定割引（％）",
    sx: { borderLeftWidth: "2px", width: "190px", textAlign: "center" },
  },
  {
    label: "粗利率（％）",
    sx: {
      width: "190px",
      textAlign: "center",
      borderLeftWidth: "2px",
    },
  },
];

export const HEADER_CATEGORY_TABLE: DataHeaderType[] = [
  {
    label: "分類コード",
    sx: {
      width: "174px",
    },
  },
  {
    label: "区分コード",
    sx: {
      width: "191px",
      textAlign: "left",
    },
  },
  {
    label: "区分",
    sx: {
      width: "304px",
      textAlign: "left",
    },
  },
  {
    label: "分類名",
    sx: {
      width: "173px",
      textAlign: "left",
    },
  },
  {
    label: "表示順 ",
    sx: {
      width: "163px",
      textAlign: "left",
    },
  },
  {
    label: "詳細",
    sx: {
      width: "211px",
    },
  },
];

export const HEADER_COMPANY_TABLE: DataHeaderType[] = [
  {
    label: "企業コード",
    sx: {
      width: "203px",
    },
  },
  {
    label: "企業名",
    sx: {
      textAlign: "left",
      width: "600px",
    },
  },
  {
    label: "店舗得意先一覧",
    sx: {
      textAlign: "center",
      width: "223px",
    },
  },
];

export const HEADER_VENDOR_TABLE: DataHeaderType[] = [
  {
    label: "仕入先コード",
    sx: {
      width: "203px",
      height: "68px",
    },
  },
  {
    label: "仕入先名",
    sx: {
      textAlign: "left",
      width: "414px",
    },
  },
  {
    label: "送信パターン",
    sx: {
      textAlign: "left",
      width: "209px",
    },
  },
  {
    label: "メールアドレス",
    sx: {
      textAlign: "left",
      width: "209px",
    },
  },
  {
    label: "詳細",
    sx: {
      textAlign: "center",
      width: "210px",
    },
  },
];

export const HEADER_WHEEL_TABLE: DataHeaderType[] = [
  {
    label: "YH商品コード",
    sx: {
      textAlign: "center",
      width: "203px",
      height: "68px",
    },
  },
  {
    label: "メーカー名",
    sx: {
      textAlign: "center",
      width: "343.5px",
    },
  },
  {
    label: "ブランドコード",
    sx: {
      textAlign: "center",
      width: "210px",
    },
  },
  {
    label: "ブランド名",
    sx: {
      textAlign: "center",
      width: "371.5px",
    },
  },
  {
    label: "サイズ / カラー",
    sx: {
      textAlign: "center",
      width: "303px",
    },
  },
  {
    label: "詳細",
    sx: {
      textAlign: "center",
      width: "223px",
    },
  },
];

export const DEFAULT_LIMIT_ITEMS = 50;

export const HEADER_WHEEL_LIST: DataHeaderType[] = [
  {
    label: "ブランドコード",
    sx: { width: "174px", textAlign: "center", px: "2px" },
  },
  {
    label: "メーカー名",
    sx: { width: "223px", textAlign: "center" },
  },
  {
    label: "ブランド名",
    sx: { width: { lg: "320px", xs: "270px" }, textAlign: "center" },
  },
  {
    label: "粗利率(%)",
    sx: { width: "130px", px: "2px", textAlign: "center" },
  },
  {
    label: "固定割引(%)",
    sx: { width: "130px", px: "2px", textAlign: "center" },
  },
  {
    label: "画像",
    sx: { width: "230px", px: 0 },
  },
];

export const HEADER_TIRE_OPTIONS: DataHeaderType[] = [
  {
    label: "商品名",
    sx: {
      width: "283px",
    },
  },
  {
    label: "販売価格条件",
    sx: {
      width: "295px",
    },
  },
  {
    label: "価格",
    sx: {
      width: "101px",
    },
  },
];

export const HEADER_NUT_WHEEL_OPTIONS: DataHeaderType[] = [
  {
    label: "JANコード",
    sx: {
      width: 220,
    },
  },
  {
    label: "商品名",
    sx: {
      width: 500,
    },
  },
  {
    label: "価格",
    sx: {
      width: 150,
    },
  },
];

export const HEADER_LOCK_NUT_WHEEL_OPTIONS: DataHeaderType[] = [
  {
    label: "JANコード",
    sx: {
      width: 220,
    },
  },
  {
    label: "商品名",
    sx: {
      width: 500,
    },
  },
  {
    label: "価格",
    sx: {
      width: 150,
    },
  },
];

export const HEADER_HUB_RING_WHEEL_OPTIONS: DataHeaderType[] = [
  {
    label: "JANコード",
    sx: {
      width: 220,
    },
  },
  {
    label: "商品名",
    sx: {
      width: 500,
    },
  },
  {
    label: "価格",
    sx: {
      width: 150,
    },
  },
];

export const HEAD_DETAIL_COMPANY: DataHeaderType[] = [
  {
    label: "店舗コード",
    sx: {
      width: "150px",
    },
  },
  {
    label: "得意先コード",
    sx: {
      width: "150px",
    },
  },
  {
    label: "店舗得意先名",
    sx: {
      width: "374px",
    },
  },
];
